import React, { useState, useEffect } from "react";
import "./PartSearch.css";

const brands = {
 Audi: ["A1","A3","A4","A5","A6","A7","A8","e-tron GT","Q2","Q3","Q4 e-tron","Q5","Q6 e-tron","Q7","Q8 e-tron"],
  Volkswagen: ["Polo","Golf","Passat","Jetta","Tiguan","T-Cross","T-Roc","Taigo","Touareg","Arteon","ID.3","ID.4","ID.5","ID.7","ID. Buzz","Caddy","Multivan","Amarok"],
  SEAT: ["Ibiza","Cordoba","Leon","Alhambra","Arosa","Ateca","Toledo","Altea","Arona","Tarraco","Mii"],
  Porsche: ["718","911","Taycan","Panamera","Macan","Cayenne","918 Spyder"],
  Škoda: ["Fabia","Scala","Octavia","Superb","Kamiq","Karoq","Kodiaq","Enyaq"],
  BMW: ["1 Serisi","2 Serisi","3 Serisi","4 Serisi","5 Serisi","6 Serisi","7 Serisi","8 Serisi","Z4","X1","X2","X3","X4","X5","X6","X7","i4","i5","i7","iX","iX M","M2","M3","M4","M5","M8","XM"],
  Mercedes: ["A-Serisi Hatchback","A-Serisi Sedan","B-Serisi","C-Serisi","C-Serisi All‑Terrain","CLA","CLA Shooting Brake","CLC","CLE Coupé","CLE Cabriolet","E-Serisi","E-Serisi Estate","EQE","EQS","GLA","GLB","GLC","GLC Coupé","GLE","GLS","G-Serisi","AMG GT 4-Kapı Coupé","AMG SL","Maybach S-Serisi","S-Serisi"]
};

function PartSearch({ onSearch }) {
  const [activeTab, setActiveTab] = useState("arac");
  const [selectedBrand, setSelectedBrand] = useState("");
  const [selectedModel, setSelectedModel] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [partName, setPartName] = useState("");
  const [oemCode, setOemCode] = useState("");

  const handleSearch = () => {
    if (activeTab === "arac") {
      onSearch({
        brand: selectedBrand,
        model: selectedModel,
        year: selectedYear,
        query: partName,
        mode: "arac"
      });
    } else {
      onSearch({
        oem: oemCode,
        query: oemCode,
        mode: "oem"
      });
    }
  };

  useEffect(() => {
    handleSearch();
  }, [selectedBrand, selectedModel, selectedYear, partName, oemCode, activeTab]);

  return (
    <div className="search-card">
      <div className="search-tabs mb-3">
        <button
          className={`tab-button ${activeTab === "arac" ? "active" : ""}`}
          onClick={() => setActiveTab("arac")}
        >
          Araç Bilgisiyle Arama
        </button>
        <button
          className={`tab-button ${activeTab === "oem" ? "active" : ""}`}
          onClick={() => setActiveTab("oem")}
        >
          OEM Kodu ile Arama
        </button>
      </div>

      {activeTab === "arac" ? (
        <div className="row g-3">
          <div className="col-md-3">
            <select
              className="form-select"
              value={selectedBrand}
              onChange={(e) => {
                setSelectedBrand(e.target.value);
                setSelectedModel("");
              }}
            >
              <option value="">Marka Seçiniz</option>
              {Object.keys(brands).map((brand) => (
                <option key={brand}>{brand}</option>
              ))}
            </select>
          </div>
          <div className="col-md-3">
            <select
              className="form-select"
              value={selectedModel}
              onChange={(e) => setSelectedModel(e.target.value)}
              disabled={!selectedBrand}
            >
              <option value="">Model Seçiniz</option>
              {selectedBrand &&
                brands[selectedBrand].map((model) => (
                  <option key={model}>{model}</option>
                ))}
            </select>
          </div>
          <div className="col-md-2">
            <select
              className="form-select"
              value={selectedYear}
              onChange={(e) => setSelectedYear(e.target.value)}
            >
              <option value="">Model Yılı</option>
              {Array.from({ length: 30 }, (_, i) => 1995 + i).map((year) => (
                <option key={year} value={year}>{year}</option>
              ))}
            </select>
          </div>
          <div className="col-md-3">
            <input
              type="text"
              className="form-control"
              placeholder="Parça adı giriniz"
              value={partName}
              onChange={(e) => setPartName(e.target.value)}
            />
          </div>
          <div className="col-md-1 d-none d-md-block">
            <button className="btn btn-primary w-100" onClick={handleSearch}>Ara</button>
          </div>
        </div>
      ) : (
        <div className="row g-3">
          <div className="col-md-10">
            <input
              type="text"
              className="form-control"
              placeholder="OEM Kodu giriniz"
              value={oemCode}
              onChange={(e) => setOemCode(e.target.value)}
            />
          </div>
          <div className="col-md-2">
            <button className="btn btn-primary w-100" onClick={handleSearch}>Ara</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default PartSearch;
